import { useEffect, useState } from "react";
import { navLinks, siteName } from "@/mocks/editorial";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "bg-background-50/90 backdrop-blur border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <nav
        className="mx-auto flex h-16 items-center justify-between px-4 md:px-6 lg:px-8"
        aria-label="主导航"
      >
        <a href="#top" className="flex items-center gap-2 whitespace-nowrap">
          <span className="grid h-9 w-9 place-items-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-flashlight-fill text-base"></i>
          </span>
          <span className="font-heading text-lg font-semibold tracking-tight text-foreground-950">
            {siteName}
          </span>
          <span className="hidden rounded-full bg-accent-100 px-2 py-0.5 text-[11px] font-medium text-accent-800 sm:inline-block">
            观察·解读·理性吃瓜
          </span>
        </a>

        {/* 桌面导航 */}
        <ul className="hidden items-center gap-1 md:flex">
          {navLinks.map((l) => (
            <li key={l.href}>
              <a
                href={l.href}
                className="whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-secondary-100 hover:text-foreground-950"
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-2">
          <a
            href="#contact"
            className="hidden whitespace-nowrap rounded-full bg-foreground-950 px-5 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
          >
            订阅观察
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label={open ? "关闭菜单" : "打开菜单"}
            aria-expanded={open}
            className="grid h-10 w-10 place-items-center rounded-md text-foreground-900 hover:bg-secondary-100 md:hidden"
          >
            <i className={`text-xl ${open ? "ri-close-line" : "ri-menu-3-line"}`}></i>
          </button>
        </div>
      </nav>

      {/* 移动端抽屉 */}
      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
          <ul className="flex flex-col gap-1">
            {navLinks.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="block rounded-md px-3 py-2 text-[15px] text-foreground-800 hover:bg-secondary-100"
                >
                  {l.label}
                </a>
              </li>
            ))}
            <li className="pt-2">
              <a
                href="#contact"
                onClick={() => setOpen(false)}
                className="block rounded-full bg-primary-500 px-5 py-2.5 text-center text-sm font-medium text-background-50"
              >
                订阅观察
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}